var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-4 px-2"},[_c('p',{staticClass:"d-flex justify-content-center bg-light p-3 text-caption"},[_vm._v("Under development..")])])
}
var staticRenderFns = []

export { render, staticRenderFns }